const PHRASES = [
  "All your favorite brands.",
  "Ready to trade for more?",
  "Millions of products available.",
];

function Group() {
  return (
    <div className="flex shrink-0">
      {PHRASES.concat(PHRASES).map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="mx-6 text-sm font-bold uppercase tracking-[0.22em] text-[#E8956B] whitespace-nowrap">
            {p}
          </span>
          <span className="text-[#E8956B]/60 text-xs">✦</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="brand-marquee"
      className="w-full bg-white border-b border-neutral-200 overflow-hidden py-2.5 marquee-pause"
    >
      <div className="flex w-max animate-marquee">
        <Group />
        <Group />
      </div>
    </div>
  );
}
